exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearfix[data-v-22bb1ee0]{*zoom:1}.clearfix[data-v-22bb1ee0]:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}", ""]);

// exports
